<script>
import PEProfileEmailModal from './PEProfileEmailModal.vue';
import { mapState } from 'vuex';
import { useModalProvider } from "@/composables/useModalProvider";

const INCORRECT_ERR = 'incorrectEmailErr';
const MANDATORY_ERR = 'contactEmailErr';

export default {
  components:{
    PEProfileEmailModal
  },
  name: 'PEContactEmailComponent',
  data: () => ({
    errorEmail: false,
    emptyEmail: false,
    changedErrorEmail: false,
    changedEmptyEmail: false,
    updatedContactEmail: '',
    emailTimer: null,
    disableSave: true,
  }),
  setup(){
    const { openModal, closeModal, isModalOpen } = useModalProvider("ProfileContactEmailModal");
    return { openModal, closeModal, isModalOpen };
  },
  methods: {
    saveContactEmail() {
      this.$store.dispatch(
        'partnerProfile/updateContactEmail',
        this.updatedContactEmail,
      );
      this.closeModalFunc();
    },
    clearChanges() {
      this.updatedContactEmail = this.contactEmail;
      this.disableSave = true;
      clearTimeout(this.emailTimer);
    },
    closeModalFunc() {
      this.closeModal()
      this.clearChanges();
      this.checkField(this.contactEmail);
      this.errorEmail = this.changedErrorEmail;
      this.emptyEmail = this.changedEmptyEmail;
    },
    updateEmail(event) {
      this.updatedContactEmail = event.target.value;
      this.disableSave = false;
      if (this.emailTimer) {
        clearTimeout(this.emailTimer);
      }
      this.emailTimer = setTimeout(() => this.checkField(event.target.value), 2000);
    },
    getContactEmail() {
      if (this.updatedContactEmail != null) {
        return this.updatedContactEmail;
      }
      if (this.contactEmail && this.contactEmail.length > 0) {
        return this.contactEmail;
      }
      return '';
    },
    checkField(email) {
      const re = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!email || email.length === 0) {
        this.changedErrorEmail = true;
        this.changedEmptyEmail = true;
      } else if (re.test(email)) {
        this.changedErrorEmail = false;
        this.changedEmptyEmail = false;
      } else {
        this.changedErrorEmail = true;
        this.changedEmptyEmail = false;
      }
    },
    handleContactEmailError(val, err, removeErr) {
      if (val) {
        this.addEmailError(err);
        this.removeEmailError(removeErr);
      } else {
        this.removeEmailError(err);
      }
      if (!val && err === MANDATORY_ERR && this.errorEmail) {
        this.addEmailError(INCORRECT_ERR);
      }
    },
    addEmailError(errorId) {
      this.$store.dispatch(
        'partnerProfile/addErrorField',
        {
          id: errorId,
          field: this.$t('field.contact.request.email'),
          message: this.getMessageByErrorId(errorId),
        },
      );
    },
    removeEmailError(errorId) {
      this.$store.dispatch('partnerProfile/removeErrorField', errorId);
    },
    getMessageByErrorId(errorId) {
      return errorId === MANDATORY_ERR
        ? this.$t('email.contact.mandatory')
        : this.$t('local.office.email.error.message');
    },
  },
  computed: {
    ...mapState('partnerProfile', {
      contactEmail: (state) => state.profileData.contactEmail,
      mountedComponent: (state) => state.mountedComponent,
    }),
  },
  watch: {
    contactEmail(val) {
      if (this.mountedComponent.includes(this.$options.name)) {
        this.updatedContactEmail = val;
        this.checkField(val);
        this.errorEmail = this.changedErrorEmail;
        this.emptyEmail = this.changedEmptyEmail;
      } else {
        this.$store.dispatch(
          'partnerProfile/addMountedComponent',
          this.$options.name,
        );
      }
    },
    errorEmail(val) {
      this.handleContactEmailError(val, INCORRECT_ERR, MANDATORY_ERR);
    },
    emptyEmail(val) {
      this.handleContactEmailError(val, MANDATORY_ERR, INCORRECT_ERR);
    },
  },
  mounted() {
    this.updatedContactEmail = this.contactEmail;
    if (this.mountedComponent.includes(this.$options.name)) {
      this.checkField(this.contactEmail);
      this.errorEmail = this.changedErrorEmail;
      this.emptyEmail = this.changedEmptyEmail;
    }
    this.$eventBus.$on('*', (type) => {
      if (['footerSaveClicked', 'footerPublishClicked', 'editorToggleButtonClicked'].includes(type)) {
        this.checkField(this.contactEmail);
        this.errorEmail = this.changedErrorEmail;
        this.emptyEmail = this.changedEmptyEmail;
      }
    });
    this.$eventBus.$on('contactEmailErr', () => {
      this.emptyEmail = true;
    });
  },
};
</script>

<template>
  <div class="contact-email-container ds-m-t-l">
    <PEProfileEmailModal 
      :email-value="getContactEmail"
      :change-email-value="updateEmail" 
      :save-change-email="saveContactEmail"
      :close-email-modal="closeModalFunc"
      :changed-error-email="changedErrorEmail"
      :showModal="isModalOpen"
      :disableSave="disableSave"
      :changed-empty-email="changedEmptyEmail"
      />
    <button
      class="ds-button ds-button--primary contact-email-button"
      :class="contactEmail && contactEmail.length > 0 ? 'ds-p-y-none' : ''"
      type="button"
      @click="openModal"
    >
      <span :class="contactEmail && contactEmail.length > 0 ? 'email-edit-small-text' : ''">
        {{
          contactEmail && contactEmail.length > 0
            ? $t("edit.email.contact")
            : $t("add.email.contact")
        }}
      </span>
      <span class="email-small-text">
        {{contactEmail}}
      </span>
    </button>
    <div class="ds-textField__message" v-show="errorEmail || emptyEmail">
      <i class="ds-icon--close-outline ds-m-r-xs"></i
      >{{
        emptyEmail
          ? $t("email.contact.mandatory")
          : $t("local.office.email.error.message")
      }}
    </div>
  </div>
</template>

<style lang="less" scoped>
.contact-email-container {
  .contact-email-button {
    &:extend(.font-normal);
    max-width: none;
    font-size: 16px;
    text-align: center;
    display: block;
  }

  .email-edit-small-text {
    &:extend(.font-normal);
    font-size: 14px;
    line-height: 23px;
    display: block;
  }
  
  .email-small-text {
    &:extend(.benton-sans-light);
    font-size: 12px;
    line-height: 17px;
    display: block;
  }

  .ds-textField__message {
    &:extend(.font-normal);
    font-size: 14px;
    color: @color-field-error;
    .ds-icon--close-outline {
      line-height: 17px;
    }
  }

  .ds-button {
    &:extend(.font-normal);
    font-size: 16px;
  }
}
</style>
